
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'feedback-public-submission-ui',
  currentProjectVersion: 'static-1.30419',
  depVersions: {
  "feedback-public-submission-ui": "static-1.30419",
  "emoji-mart": "static-3.4",
  "feedback-schema": "static-1.54779",
  "head-dlb": "static-1.5007",
  "hs-test-utils": "static-1.8092",
  "hubspot-dlb": "static-2.1854",
  "HubStyleTokens": "static-2.11550",
  "I18n": "static-7.1634",
  "quartz": "static-1.7120",
  "quartz-config": "static-1.898",
  "quartz-core": "static-1.6339",
  "react-dlb": "static-1.80",
  "react-dnd": "static-4.51",
  "react-dnd-html5-backend": "static-2.10",
  "redux-mock-store": "static-1.8",
  "redux-thunk": "static-2.43",
  "sinon": "static-1.9",
  "tinymce": "static-6.5",
  "cssUtils": "static-1.814",
  "enviro": "static-4.455",
  "feedback-shared-ui": "static-1.54766",
  "feedback-utils": "static-1.54770",
  "forms-embed-utils-lib": "static-1.4539",
  "forms-utils-lib": "static-1.12722",
  "foundations-assets": "static-1.4945",
  "foundations-components": "static-1.8077",
  "foundations-theming": "static-1.4505",
  "hub-http": "static-1.6297",
  "hubspot-url-utils": "static-1.4132",
  "HubStyle": "static-2.11857",
  "icons": "static-2.651",
  "immutable": "static-2.79",
  "quick-fetch": "static-1.3976",
  "raven": "static-3.5925",
  "react": "static-7.187",
  "react-dom": "static-7.85",
  "react-input-autosize": "static-2.17",
  "react-redux": "static-7.71",
  "react-rhumb": "static-1.16756",
  "react-select-plus": "static-1.106",
  "react-utils": "static-2.5401",
  "react-virtualized": "static-2.100",
  "redux": "static-4.16",
  "StyleGuideUI": "static-3.488",
  "tinymce-plugins": "static-1.57688",
  "transmute": "static-2.85",
  "ui-images": "static-2.1172",
  "UIComponents": "static-3.8496",
  "hs-promise-rejection-tracking": "static-1.5587",
  "PortalIdParser": "static-2.404",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "metrics-js": "static-1.9637",
  "styled-components": "static-2.89",
  "bend-plugin-trellis-migration": "static-1.3458",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.3397",
  "quartz-webpack": "static-1.3344",
  "foundations-theming-specialty": "static-1.2221",
  "property-description-translator": "static-1.3914",
  "HeadJS": "static-2.766",
  "framer-motion": "static-1.73",
  "hs-test-utils-bend-plugin": "static-1.3203",
  "msw": "static-1.39",
  "testing-library": "static-1.153",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.222",
  "moment-timezone": "static-5.84",
  "jasmine": "static-4.4400",
  "jasmine-runner": "static-1.6537",
  "dispatcher": "static-1.137",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.841",
  "hubspotter-http": "static-1.4709",
  "mobile-manifest-mixins": "static-1.540",
  "module-federation": "static-1.24",
  "quartz-auth": "static-1.795",
  "quartz-head": "static-1.785",
  "quartz-i18n": "static-1.795",
  "quartz-routing": "static-1.550",
  "quartz-test": "static-1.795",
  "quartz-tracking": "static-1.499",
  "trellis-components": "static-1.2144",
  "ui-fonts": "static-1.812",
  "usage-tracker-container": "static-1.7414",
  "usage-tracker-core": "static-1.7274",
  "hs-lodash": "static-4.45",
  "sassPrefix": "static-1.157",
  "conversations-skeleton-state": "static-1.7324",
  "reference-resolvers": "static-1.8248",
  "sanitize-text": "static-1.8219",
  "PatternValidationJS": "static-1.437",
  "ReduxMessenger": "static-2.10438",
  "sanitize": "static-1.4551",
  "outpost": "static-1.4247",
  "rpc-client-utils": "static-1.4729",
  "underscore": "static-1.8",
  "bend-plugin-foundations-components": "static-1.4346",
  "floating-ui": "static-1.57",
  "hs-story-utils": "static-1.9497",
  "react-aria": "static-1.67",
  "react-create-root-preference": "static-1.32",
  "tanstack-table": "static-1.56",
  "trellis-assets": "static-1.2125",
  "bend-plugin-foundations-theming": "static-1.2988",
  "foundations-theming-base": "static-1.3490",
  "stylex": "static-1.34",
  "hs-locale-management": "static-1.139",
  "csstype": "static-1.50",
  "web-vitals": "static-1.7",
  "ai-components-ui-library": "static-1.9148",
  "atom": "static-1.5149",
  "codemirror": "static-5.96",
  "content-assistance-lib": "static-1.7868",
  "ContentUtils": "static-1.68580",
  "data-token-picker": "static-1.16535",
  "file-manager-components": "static-1.23817",
  "FileManagerCore": "static-1.39316",
  "FileManagerLib": "static-1.39457",
  "frontend-preferences-client": "static-1.8001",
  "hub-http-contrib": "static-1.3116",
  "interframe": "static-3.4834",
  "layout-dnd-components": "static-1.12586",
  "layout-dnd-utils": "static-1.11561",
  "property-translator": "static-1.5470",
  "react-codemirror": "static-1.10702",
  "react-colorpicker": "static-2.10284",
  "reference-resolvers-lite": "static-1.8173",
  "rich-text-lib": "static-1.19954",
  "tinymce-data": "static-1.40659",
  "tinymce-themes": "static-1.56544",
  "ui-addon-emoji-picker": "static-1.9962",
  "ui-addon-sales-email": "static-1.5286",
  "ui-brand-identity-lib": "static-1.15558",
  "bender-build-tools": "static-1.3260",
  "hub-http-shared-msw-handlers": "static-1.10142",
  "hubspotter-http-shared-msw-handlers": "static-1.10140",
  "usage-tracker-session-replay": "static-1.5110",
  "base-ui": "static-1.12",
  "react-day-picker": "static-1.4",
  "trellis-theming": "static-1.1012",
  "tanstack-virtual": "static-1.31",
  "react-immutable-proptypes": "static-2.8",
  "autolinker": "static-3.11",
  "bend-plugin-chirp-manifest": "static-1.139",
  "chirp-fetch": "static-1.1962",
  "chatspot-core": "static-1.21659",
  "copilot-toolkit": "static-1.11331",
  "customer-data-objects-ui-components": "static-1.13107",
  "data-fetching-client": "static-1.9738",
  "diff-match-patch": "static-1.7",
  "superstore": "static-1.4835",
  "ui-addon-video-player": "static-1.8779",
  "ui-coaching-tips": "static-1.28770",
  "usage-tracker": "static-1.7424",
  "cms-field-types": "static-1.4887",
  "content-icons-ui": "static-1.2248",
  "integrations-lib": "static-1.16406",
  "customer-data-objects": "static-1.7752",
  "apollo-dlb": "static-3.86",
  "apollo-link-hub-http": "static-2.4727",
  "apollo-stack-hubspot": "static-3.87",
  "graphql": "static-1.83",
  "immer": "static-1.33",
  "immerable": "static-1.4229",
  "ui-addon-iframeable": "static-1.9136",
  "video-components-external": "static-1.11529",
  "video-data-lib": "static-1.35187",
  "audio-components": "static-1.6026",
  "cropperjs": "static-1.10",
  "feedback-loader": "static-1.29433",
  "FileManagerImages": "static-1.36968",
  "foundations-components-legacy": "static-1.1102",
  "html-to-image": "static-1.55",
  "redux-toolkit": "static-1.7",
  "reselect": "static-2.16",
  "salesImages": "static-1.526",
  "ui-universal-auth": "static-1.9066",
  "urlinator": "static-1.4611",
  "video-components": "static-1.13531",
  "video-embed": "static-1.36021",
  "ts-schema": "static-1.4138",
  "ContentData": "static-1.68655",
  "layout-data-lib": "static-1.9886",
  "react-dnd-compat": "static-1.4689",
  "browser-eslint": "static-2.57",
  "batch-promise": "static-1.1617",
  "external-options-client-types": "static-1.4199",
  "fast-json-stable-stringify": "static-1.4",
  "framework-data-schema-resolvers": "static-1.6964",
  "hs-promise-utils": "static-1.5666",
  "inbound-db-properties-service-client": "static-1.3902",
  "NamespacedHubStyle": "static-2.9116",
  "growth-onboarding-confetti": "static-1.3141",
  "SharedI18nStrings": "static-1.182",
  "ui-addon-i18n": "static-1.11226",
  "amplitude-session-replay-browser": "static-1.60",
  "markdown-it": "static-1.6",
  "breeze-engine-lib": "static-1.961",
  "magpie-lib": "static-1.5602",
  "magpie-types": "static-1.5062",
  "simple-logging-lib": "static-1.3125",
  "avatar-components": "static-1.2572",
  "customer-data-ui-utilities": "static-1.9900",
  "growth-onboarding-feedback-components": "static-1.6654",
  "flux-actions": "static-1.343",
  "hubspot-apollo-client": "static-1.4952",
  "integrations-error-boundary-lib": "static-1.13821",
  "integrations-tracking-lib": "static-1.5681",
  "laboratory-lib": "static-3.7230",
  "native-integrations-shared-strings": "static-1.7856",
  "redux-observable": "static-1.11",
  "rxjs": "static-5.10",
  "ui-shepherd-react": "static-3.10294",
  "unified-auth": "static-1.580",
  "navigation-messaging": "static-1.7546",
  "content-media-composition-data-lib": "static-1.12575",
  "content-media-compositions": "static-2.16582",
  "idb-keyval": "static-1.45",
  "media-bridge-lib": "static-1.19052",
  "unified-auth-core-lib": "static-1.862",
  "social-insights-client-types": "static-1.22278",
  "advanced-menus-core": "static-1.15246",
  "advanced-menus-lib": "static-1.12171",
  "ExportDialog": "static-6.10459",
  "ui-memberships-settings-lib": "static-1.34249",
  "conditional-properties-service-client": "static-1.3855",
  "crm-pipelines-api-client-types": "static-1.4196",
  "fdsr-migration-layer": "static-1.83",
  "framework-builder-read-service-client": "static-1.4063",
  "framework-data-schema-quick-fetch": "static-1.6869",
  "inbound-db-meta-service-client": "static-1.3644",
  "multi-currency-client-types": "static-1.3749",
  "persist-promise": "static-1.3774",
  "foundations-components-test-utils": "static-1.5560",
  "breeze-engine-core": "static-1.239",
  "ably": "static-2.2",
  "highlight.js": "static-1.80",
  "reactive-lib": "static-1.800",
  "react-immutable-render-mixin": "static-1.9",
  "hubspot-apollo-cache": "static-1.411",
  "universal-page-editor-lib": "static-1.3093",
  "ads-unified-auth-lib": "static-1.172",
  "google-sheets-integration-lib": "static-1.456",
  "microsoft-drive-integration-lib": "static-1.596",
  "slack-ui-library": "static-1.10467",
  "js-cookie": "static-1.18",
  "fsm": "static-1.3804",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15245",
  "simple-menus-lib": "static-1.16762",
  "crm-record-cards-service-types": "static-1.3648",
  "location-customization-utils-lib": "static-1.9479",
  "react-flip-move": "static-1.72"
},
  depPathPrefixes: {
  "feedback-public-submission-ui": "/feedback-public-submission-ui/static-1.30419",
  "emoji-mart": "/emoji-mart/static-3.4",
  "feedback-schema": "/feedback-schema/static-1.54779",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-test-utils": "/hs-test-utils/static-1.8092",
  "hubspot-dlb": "/hubspot-dlb/static-2.1854",
  "HubStyleTokens": "/HubStyleTokens/static-2.11550",
  "I18n": "/I18n/static-7.1634",
  "quartz": "/quartz/static-1.7120",
  "quartz-config": "/quartz-config/static-1.898",
  "quartz-core": "/quartz-core/static-1.6339",
  "react-dlb": "/react-dlb/static-1.80",
  "react-dnd": "/react-dnd/static-4.51",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-2.10",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-thunk": "/redux-thunk/static-2.43",
  "sinon": "/sinon/static-1.9",
  "tinymce": "/tinymce/static-6.5",
  "cssUtils": "/cssUtils/static-1.814",
  "enviro": "/enviro/static-4.455",
  "feedback-shared-ui": "/feedback-shared-ui/static-1.54766",
  "feedback-utils": "/feedback-utils/static-1.54770",
  "forms-embed-utils-lib": "/forms-embed-utils-lib/static-1.4539",
  "forms-utils-lib": "/forms-utils-lib/static-1.12722",
  "foundations-assets": "/foundations-assets/static-1.4945",
  "foundations-components": "/foundations-components/static-1.8077",
  "foundations-theming": "/foundations-theming/static-1.4505",
  "hub-http": "/hub-http/static-1.6297",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4132",
  "HubStyle": "/HubStyle/static-2.11857",
  "icons": "/icons/static-2.651",
  "immutable": "/immutable/static-2.79",
  "quick-fetch": "/quick-fetch/static-1.3976",
  "raven": "/raven/static-3.5925",
  "react": "/react/static-7.187",
  "react-dom": "/react-dom/static-7.85",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-redux": "/react-redux/static-7.71",
  "react-rhumb": "/react-rhumb/static-1.16756",
  "react-select-plus": "/react-select-plus/static-1.106",
  "react-utils": "/react-utils/static-2.5401",
  "react-virtualized": "/react-virtualized/static-2.100",
  "redux": "/redux/static-4.16",
  "StyleGuideUI": "/StyleGuideUI/static-3.488",
  "tinymce-plugins": "/tinymce-plugins/static-1.57688",
  "transmute": "/transmute/static-2.85",
  "ui-images": "/ui-images/static-2.1172",
  "UIComponents": "/UIComponents/static-3.8496",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "metrics-js": "/metrics-js/static-1.9637",
  "styled-components": "/styled-components/static-2.89",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3458",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3397",
  "quartz-webpack": "/quartz-webpack/static-1.3344",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2221",
  "property-description-translator": "/property-description-translator/static-1.3914",
  "HeadJS": "/HeadJS/static-2.766",
  "framer-motion": "/framer-motion/static-1.73",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3203",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.153",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.222",
  "moment-timezone": "/moment-timezone/static-5.84",
  "jasmine": "/jasmine/static-4.4400",
  "jasmine-runner": "/jasmine-runner/static-1.6537",
  "dispatcher": "/dispatcher/static-1.137",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.841",
  "hubspotter-http": "/hubspotter-http/static-1.4709",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.540",
  "module-federation": "/module-federation/static-1.24",
  "quartz-auth": "/quartz-auth/static-1.795",
  "quartz-head": "/quartz-head/static-1.785",
  "quartz-i18n": "/quartz-i18n/static-1.795",
  "quartz-routing": "/quartz-routing/static-1.550",
  "quartz-test": "/quartz-test/static-1.795",
  "quartz-tracking": "/quartz-tracking/static-1.499",
  "trellis-components": "/trellis-components/static-1.2144",
  "ui-fonts": "/ui-fonts/static-1.812",
  "usage-tracker-container": "/usage-tracker-container/static-1.7414",
  "usage-tracker-core": "/usage-tracker-core/static-1.7274",
  "hs-lodash": "/hs-lodash/static-4.45",
  "sassPrefix": "/sassPrefix/static-1.157",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7324",
  "reference-resolvers": "/reference-resolvers/static-1.8248",
  "sanitize-text": "/sanitize-text/static-1.8219",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "ReduxMessenger": "/ReduxMessenger/static-2.10438",
  "sanitize": "/sanitize/static-1.4551",
  "outpost": "/outpost/static-1.4247",
  "rpc-client-utils": "/rpc-client-utils/static-1.4729",
  "underscore": "/underscore/static-1.8",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4346",
  "floating-ui": "/floating-ui/static-1.57",
  "hs-story-utils": "/hs-story-utils/static-1.9497",
  "react-aria": "/react-aria/static-1.67",
  "react-create-root-preference": "/react-create-root-preference/static-1.32",
  "tanstack-table": "/tanstack-table/static-1.56",
  "trellis-assets": "/trellis-assets/static-1.2125",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2988",
  "foundations-theming-base": "/foundations-theming-base/static-1.3490",
  "stylex": "/stylex/static-1.34",
  "hs-locale-management": "/hs-locale-management/static-1.139",
  "csstype": "/csstype/static-1.50",
  "web-vitals": "/web-vitals/static-1.7",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9148",
  "atom": "/atom/static-1.5149",
  "codemirror": "/codemirror/static-5.96",
  "content-assistance-lib": "/content-assistance-lib/static-1.7868",
  "ContentUtils": "/ContentUtils/static-1.68580",
  "data-token-picker": "/data-token-picker/static-1.16535",
  "file-manager-components": "/file-manager-components/static-1.23817",
  "FileManagerCore": "/FileManagerCore/static-1.39316",
  "FileManagerLib": "/FileManagerLib/static-1.39457",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8001",
  "hub-http-contrib": "/hub-http-contrib/static-1.3116",
  "interframe": "/interframe/static-3.4834",
  "layout-dnd-components": "/layout-dnd-components/static-1.12586",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11561",
  "property-translator": "/property-translator/static-1.5470",
  "react-codemirror": "/react-codemirror/static-1.10702",
  "react-colorpicker": "/react-colorpicker/static-2.10284",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8173",
  "rich-text-lib": "/rich-text-lib/static-1.19954",
  "tinymce-data": "/tinymce-data/static-1.40659",
  "tinymce-themes": "/tinymce-themes/static-1.56544",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9962",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5286",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.15558",
  "bender-build-tools": "/bender-build-tools/static-1.3260",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10142",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10140",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5110",
  "base-ui": "/base-ui/static-1.12",
  "react-day-picker": "/react-day-picker/static-1.4",
  "trellis-theming": "/trellis-theming/static-1.1012",
  "tanstack-virtual": "/tanstack-virtual/static-1.31",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "autolinker": "/autolinker/static-3.11",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.139",
  "chirp-fetch": "/chirp-fetch/static-1.1962",
  "chatspot-core": "/chatspot-core/static-1.21659",
  "copilot-toolkit": "/copilot-toolkit/static-1.11331",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13107",
  "data-fetching-client": "/data-fetching-client/static-1.9738",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "superstore": "/superstore/static-1.4835",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8779",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28770",
  "usage-tracker": "/usage-tracker/static-1.7424",
  "cms-field-types": "/cms-field-types/static-1.4887",
  "content-icons-ui": "/content-icons-ui/static-1.2248",
  "integrations-lib": "/integrations-lib/static-1.16406",
  "customer-data-objects": "/customer-data-objects/static-1.7752",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4727",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.87",
  "graphql": "/graphql/static-1.83",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.4229",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9136",
  "video-components-external": "/video-components-external/static-1.11529",
  "video-data-lib": "/video-data-lib/static-1.35187",
  "audio-components": "/audio-components/static-1.6026",
  "cropperjs": "/cropperjs/static-1.10",
  "feedback-loader": "/feedback-loader/static-1.29433",
  "FileManagerImages": "/FileManagerImages/static-1.36968",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1102",
  "html-to-image": "/html-to-image/static-1.55",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "reselect": "/reselect/static-2.16",
  "salesImages": "/salesImages/static-1.526",
  "ui-universal-auth": "/ui-universal-auth/static-1.9066",
  "urlinator": "/urlinator/static-1.4611",
  "video-components": "/video-components/static-1.13531",
  "video-embed": "/video-embed/static-1.36021",
  "ts-schema": "/ts-schema/static-1.4138",
  "ContentData": "/ContentData/static-1.68655",
  "layout-data-lib": "/layout-data-lib/static-1.9886",
  "react-dnd-compat": "/react-dnd-compat/static-1.4689",
  "browser-eslint": "/browser-eslint/static-2.57",
  "batch-promise": "/batch-promise/static-1.1617",
  "external-options-client-types": "/external-options-client-types/static-1.4199",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6964",
  "hs-promise-utils": "/hs-promise-utils/static-1.5666",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3902",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9116",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3141",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11226",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "markdown-it": "/markdown-it/static-1.6",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.961",
  "magpie-lib": "/magpie-lib/static-1.5602",
  "magpie-types": "/magpie-types/static-1.5062",
  "simple-logging-lib": "/simple-logging-lib/static-1.3125",
  "avatar-components": "/avatar-components/static-1.2572",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9900",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6654",
  "flux-actions": "/flux-actions/static-1.343",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4952",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13821",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5681",
  "laboratory-lib": "/laboratory-lib/static-3.7230",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7856",
  "redux-observable": "/redux-observable/static-1.11",
  "rxjs": "/rxjs/static-5.10",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10294",
  "unified-auth": "/unified-auth/static-1.580",
  "navigation-messaging": "/navigation-messaging/static-1.7546",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.12575",
  "content-media-compositions": "/content-media-compositions/static-2.16582",
  "idb-keyval": "/idb-keyval/static-1.45",
  "media-bridge-lib": "/media-bridge-lib/static-1.19052",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.862",
  "social-insights-client-types": "/social-insights-client-types/static-1.22278",
  "advanced-menus-core": "/advanced-menus-core/static-1.15246",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12171",
  "ExportDialog": "/ExportDialog/static-6.10459",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34249",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3855",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4196",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.83",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4063",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6869",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3644",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3749",
  "persist-promise": "/persist-promise/static-1.3774",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5560",
  "breeze-engine-core": "/breeze-engine-core/static-1.239",
  "ably": "/ably/static-2.2",
  "highlight.js": "/highlight.js/static-1.80",
  "reactive-lib": "/reactive-lib/static-1.800",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.411",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3093",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.172",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.456",
  "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.596",
  "slack-ui-library": "/slack-ui-library/static-1.10467",
  "js-cookie": "/js-cookie/static-1.18",
  "fsm": "/fsm/static-1.3804",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15245",
  "simple-menus-lib": "/simple-menus-lib/static-1.16762",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3648",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9479",
  "react-flip-move": "/react-flip-move/static-1.72"
}
};
